module.exports = new __parcel__URL__("ledger-icon.7213d67e.png").toString();